module.exports = __webpack_public_path__ + "img/arrow-right-small.74cbcea8.svg";